/**
 * Just like Number.isFinite, but declares a type guard.
 */
export function isFiniteNumber(x: unknown): x is number {
    return Number.isFinite(x);
}

/**
 * Like `x % base`, but always positive.
 */
export function mod(x: number, base: number) {
    return ((x % base) + base) % base;
}
